import { Customer, CustomerChange, CustomerChangeEntry } from '../types';

/**
 * Aenderungshistorie der Kunden-Stammdaten.
 *
 * Historisiert werden identitaetsrelevante Felder (Kundennummer, Name,
 * Anschrift, Kontakt) — NICHT Notizen, Bewertungen oder Konditionen: dort ist der
 * aktuelle Stand die einzige interessante Wahrheit, und jedes getippte
 * Zeichen im Log waere Rauschen. Pur: Zeitpunkt kommt vom Aufrufer.
 */

/**
 * Kundentyp lesbar. Fehlend zaehlt als 'Unternehmen' — genau wie in der App:
 * sonst erzeugte allein das nachtraegliche Setzen des Felds am Altbestand
 * einen Historien-Eintrag ohne inhaltliche Aenderung.
 */
const customerTypeLabel = (v: unknown): string => (v === 'person' ? 'Privatperson' : 'Unternehmen');

const TRACKED: Array<{ key: keyof Customer; label: string; format?: (v: unknown) => string }> = [
    { key: 'customerNumber', label: 'Kundennummer' },
    { key: 'customerType', label: 'Kundentyp', format: customerTypeLabel },
    { key: 'salutation', label: 'Anrede' },
    { key: 'title', label: 'Titel' },
    { key: 'firstName', label: 'Vorname' },
    { key: 'lastName', label: 'Nachname' },
    { key: 'name', label: 'Name' },
    { key: 'address', label: 'Adresse' },
    { key: 'street', label: 'Straße' },
    { key: 'zip', label: 'PLZ' },
    { key: 'city', label: 'Ort' },
    { key: 'email', label: 'E-Mail' },
    { key: 'phone', label: 'Telefon' },
    { key: 'website', label: 'Website' },
];

/** ''/undefined/null fallen zusammen — ein geleertes Feld ist erst mit echtem Vorwert eine Aenderung. */
const norm = (v: unknown): string => (typeof v === 'string' ? v.trim() : '');

export const diffCustomerChanges = (before: Customer, after: Customer): CustomerChange[] => {
    const out: CustomerChange[] = [];
    for (const { key, label, format } of TRACKED) {
        const from = format ? format(before[key]) : norm(before[key]);
        const to = format ? format(after[key]) : norm(after[key]);
        if (from === to) continue;
        out.push({ field: label, from: from || undefined, to: to || undefined });
    }
    return out;
};

/**
 * Neuen Eintrag anhaengen. Ohne Aenderungen kommt dieselbe Referenz zurueck —
 * der Aufrufer erkennt daran, dass nichts zu speichern ist.
 */
export const appendChangeEntry = (
    log: CustomerChangeEntry[],
    changes: CustomerChange[],
    atIso: string,
    by?: string,
): CustomerChangeEntry[] => {
    if (!changes.length) return log;
    return [...log, { at: atIso, by, changes }];
};
